/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as basketActions from '../../actions/components/basket'
import * as stepperActions from '../../actions/components/stepper'
import * as optionGroupsActions from '../../actions/components/optionGroups'

/**
 * Import Component
 */
import OptionStepper from '../../components/OptionStepper'

/**
 * Declare Variable
 */
const mapStateToProps = (state) => {
  return {
    orders: state.orders,
    stash: state.stash,
    stashByOptionGroups: state.stashByOptionGroups,
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    addToOrder,
  } = bindActionCreators(basketActions, dispatch)
  const {
    switchBottomSheet,
  } = bindActionCreators(stepperActions, dispatch)
  const {
    addStashByOptionGroups,
    removeStashByOptionGroups,
  } = bindActionCreators(optionGroupsActions, dispatch)
  return {
    addToOrder,
    switchBottomSheet,
    addStashByOptionGroups,
    removeStashByOptionGroups,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(OptionStepper))



// WEBPACK FOOTER //
// ./src/containers/components/OptionStepper.js